import Select from "PFComponents/select/select";
import { FiltersConfigTemplate } from "PFTypes/filters_config";
import { SelectOption } from "PFTypes/selector";
import React, { useMemo, useState } from "react";

type FilterConfigSearchProps = {
  template: FiltersConfigTemplate;
  selected: string | null | undefined;
  onSelect: (configId: string) => void;
};

export const FilterConfigSearch = ({ template, selected, onSelect }: FilterConfigSearchProps) => {
  const [search, setSearch] = useState("");
  const [isOpen, setIsOpen] = useState("");

  const targetOptions = useMemo<SelectOption[]>(
    () =>
      (template?.targets || [])
        .filter((target) => target.includes(search) || search.includes(target))
        .map((target) => ({
          id: target,
          item: target,
          displayElement: target
        })),
    [template?.targets, search]
  );

  const handleSearch = (newValue: string) => setSearch(newValue);

  return (
    <Select
      // @ts-ignore
      options={targetOptions}
      value={isOpen ? search : selected}
      controlledValue
      handleInputChange={handleSearch}
      handleChange={onSelect}
      handleDropDownToggle={setIsOpen}
    />
  );
};
